import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span
        aria-hidden="true"
        className="pointer-events-none select-none text-[10rem] font-black leading-none text-background-200 md:text-[14rem]"
      >
        404
      </span>
      <h1 className="mt-4 text-xl font-semibold text-foreground-950 md:text-2xl">
        This page has not been generated
      </h1>
      <p className="mt-2 font-mono text-base text-foreground-500">{location.pathname}</p>
      <p className="mt-4 text-lg text-foreground-600 md:text-xl">
        Tell me more about this page, so I can generate it
      </p>
    </div>
  );
}